"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SHOW_RULES_AND_GUIDELINES = exports.MOTION_DIV_PROPS = exports.IMAGE_UPLOAD_INPUT = exports.IMAGE_UPLOAD = exports.ADD_PHOTO = void 0;
const IMAGE_UPLOAD = exports.IMAGE_UPLOAD = 'image-upload';
const IMAGE_UPLOAD_INPUT = exports.IMAGE_UPLOAD_INPUT = 'image-upload-input';
const ADD_PHOTO = exports.ADD_PHOTO = 'add-photo';
const SHOW_RULES_AND_GUIDELINES = exports.SHOW_RULES_AND_GUIDELINES = 'show-rules-and-guidelines';
const MOTION_DIV_PROPS = exports.MOTION_DIV_PROPS = {
  initial: {
    height: 0,
    opacity: 0
  },
  animate: {
    height: 'auto',
    opacity: 1
  },
  transition: {
    duration: 0.3,
    ease: 'easeIn'
  }
};
